<template>
  <a-form :disabled="false">
    <div class="flex items-center justify-between">
      <div>
        <slot />
      </div>
      <div class="flex gap-2">
        <!-- <a-tooltip title="密度">
          <a-dropdown trigger="click" placement="bottom">
            <span class="i-carbon:desk-adjustable"></span>
            <template #overlay>
              <a-menu>
                <a-menu-item v-for="item in menuList" :key="item.value" @click="tableSize = item.value">
                  <div :class="tableSize === item.value ? 'c-[var(--color-info)]' : ''">
                    {{ item.title }}
                  </div>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </a-tooltip> -->
        <a-tooltip title="列设置">
          <a-popover trigger="click" placement="bottomRight" v-model:open="visible">
            <template #content>
              <div class="flex items-center justify-between pb-2" style="border-bottom: 1px solid #eee">
                <a-checkbox v-model:checked="state.checkAll" :indeterminate="state.indeterminate" @change="onCheckAllChange">全选</a-checkbox>
                <!-- <a-checkbox v-model:checked="serialNumberColumnChecked">序号列</a-checkbox> -->
              </div>
              <a-checkbox-group v-model:value="tooltipList" class="block max-h-80 overflow-x-hidden overflow-y-auto">
                <VueDraggable v-model="columnsWithId" :animation="150" ghostClass="ghost">
                  <div v-for="item in columnsWithId" :key="item._id" class="my-2 w-40 flex justify-between">
                    <a-checkbox :value="item._id">
                      <!-- <span class="inline-block w-24 truncate">{{ item.title }} </span> -->
                      <a-tooltip v-if="item.title && isString(item.title) && item.title.length > 9" :title="item.title">
                        <span>{{ `${item.title.slice(0, 9)}...` }}</span>
                      </a-tooltip>
                      <span v-else>{{ item.title }}</span>
                    </a-checkbox>
                    <!-- <div>
                      <a-tooltip title="固定到左侧">
                        <span
                          class="i-carbon:open-panel-filled-left hover:c-[var(--color-info)]"
                          :class="item.fixed === 'left' ? 'c-[var(--color-info)]' : ''"
                          @click="handleFixed(item, 'left')"
                        ></span>
                      </a-tooltip>
                      <a-tooltip title="固定到右侧">
                        <span
                          class="i-carbon:open-panel-filled-right hover:c-[var(--color-info)]"
                          :class="item.fixed === 'right' ? 'c-[var(--color-info)]' : ''"
                          @click="handleFixed(item, 'right')"
                        ></span>
                      </a-tooltip>
                    </div> -->
                  </div>
                </VueDraggable>
              </a-checkbox-group>
              <div class="flex justify-end pt-2" style="border-top: 1px solid #eee">
                <a-button class="mr-2" size="small" @click="handleClick('cancel')">取消</a-button>
                <a-button type="primary" size="small" @click="handleClick('confirm')">确认</a-button>
              </div>
            </template>
            <span class="i-carbon:settings"></span>
          </a-popover>
        </a-tooltip>
      </div>
    </div>
  </a-form>
</template>
<script lang="ts" setup>
import { VueDraggable } from 'vue-draggable-plus'
import type { IColumnsWithId } from '../types'
import { type SizeType } from 'ant-design-vue/es/config-provider'
import * as func from '@/func'
import { aCommodity } from '@/apis'
import { isString } from 'lodash-es'

const props = defineProps<{
  tableName?: string
  columnsHiddenKeys: string[]
}>()

const menuList: { title: string; value: SizeType }[] = [
  {
    title: '宽松',
    value: 'large',
  },
  {
    title: '默认',
    value: 'middle',
  },
  {
    title: '紧凑',
    value: 'small',
  },
]
const columnsWithId = defineModel<IColumnsWithId[]>('columnsWithId', { required: true })
const serialNumberColumnChecked = defineModel<boolean>('serialNumberColumnChecked', { required: true })
const handleFixed = (item: IColumnsWithId, direction: 'left' | 'right') => {
  const currentIndex = columnsWithId.value.findIndex((i) => i._id === item._id)
  columnsWithId.value.splice(currentIndex, 1)
  if (item.fixed === direction) {
    item.fixed = false
    if (direction === 'left') {
      const currentIndex = columnsWithId.value.findIndex((i) => i.fixed !== 'left')
      columnsWithId.value.splice(currentIndex, 0, item)
    } else {
      let currentIndex = columnsWithId.value.length - 1
      for (let i = currentIndex; i >= 0; i--) {
        const current = columnsWithId.value[i]
        if (current.fixed !== 'right') {
          currentIndex = i
          break
        }
      }
      columnsWithId.value.splice(currentIndex, 0, item)
    }
  } else {
    item.fixed = direction
    if (direction === 'left') {
      columnsWithId.value.unshift(item)
    } else {
      columnsWithId.value.push(item)
    }
  }
}
const state = reactive({
  indeterminate: true,
  checkAll: false,
})
const checkedList = defineModel<string[]>('checkedList', { required: true })
const tooltipList = ref<string[]>([])
const tableSize = defineModel<SizeType>('tableSize', { required: true })
const onCheckAllChange = (e: any) => {
  Object.assign(state, {
    indeterminate: false,
  })
  tooltipList.value = e.target.checked ? columnsWithId.value.map((i) => i._id) : []
}
watch(
  tooltipList,
  (val) => {
    state.indeterminate = !!val.length && val.length < columnsWithId.value.length
    state.checkAll = val.length === columnsWithId.value.length
  },
  {
    immediate: true,
  }
)
const route = useRoute()
const pagePath = func.getRouteName(`${route.path}`) + `-${props.tableName}`
const visible = ref<boolean>(false)
let isFirst = false
// 获取不展示列
const init = () => {
  if (isFirst) return
  isFirst = true
  if (!props.tableName) return console.error('展示列设置按钮时，需设置tableName字段，且保证同一路由下tableName字段的唯一性')
  // let list = columnsWithId.value.map((a) => a._id)
  let list = checkedList.value
  tooltipList.value = list
  aCommodity.page
    .selectDetail({ pagePath })
    .then((res) => {
      const pageFields = res.fields
      const data = pageFields !== null ? pageFields.split(',') : props.columnsHiddenKeys || []
      list = columnsWithId.value.map((a) => a._id).filter((i) => !data.includes(i))
      // 设置默认不展示列
      if (props.columnsHiddenKeys && pageFields == null) {
        aCommodity.page.updateDispositionFields({ pagePath, fields: props.columnsHiddenKeys.join(',') })
      }
    })
    .finally(() => {
      checkedList.value = tooltipList.value = list
    })
}
// 保存不展示列
const handleClick = (type: 'confirm' | 'cancel') => {
  if (type == 'confirm') {
    checkedList.value = tooltipList.value
    const fields = columnsWithId.value
      .filter((i) => !tooltipList.value.includes(i._id))
      .map((a) => a._id)
      .join(',')
    aCommodity.page.updateDispositionFields({ pagePath, fields })
  } else {
    tooltipList.value = checkedList.value
  }
  visible.value = false
}

onBeforeMount(() => {
  init()
})
onActivated(() => {
  init()
})
onDeactivated(() => {
  isFirst = false
})
</script>
<style lang="scss" scoped></style>
